import { render, staticRenderFns } from "./user-order-observer.vue?vue&type=template&id=09d40df2&scoped=true&"
import script from "./user-order-observer.vue?vue&type=script&lang=ts&"
export * from "./user-order-observer.vue?vue&type=script&lang=ts&"
import style0 from "./user-order-observer.vue?vue&type=style&index=0&id=09d40df2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d40df2",
  null
  
)

export default component.exports